import { Box } from "@mui/material";
import { useEffect, useRef } from "react";
import useVirtualViewport from "../../../hooks/useVirtualViewport";
import { Navigate, Outlet, useLocation, useNavigate } from "react-router-dom";

import {
  setHasScroll,
  setOpenAuthSidebar,
  setOpenDriverSidebar,
  setOpenOwnerSidebar,
} from "../../../redux/features/settingSlice";
import { useAppDispatch, useAppSelector } from "../../../hooks/useRedux";
import OwnerSidebar from "./Sidebar";
import BottomTabbar from "./BottomTabbar";
import CustomSnackbar from "../../components/CustomSnackbar";
import CustomDialogBox from "../../components/CustomDialogBox";
import useSWRMutation from "swr/mutation";
import { fetcherPost } from "../../../services/fetcher";
import {
  setAccomodationInfo,
  setAttachFiles,
  setBankAccountInfo,
  setBirthDate,
  setOwnerConfirm,
  setOwnerInfo,
  setOwnerStock,
  setPhoneValid,
} from "../../../redux/features/ownerSlice";
import {
  setOpenSnackbar,
  setSnackbarDescription,
  setSnackbarErrorStatus,
} from "../../../redux/features/snackbarSlice";
import Goftino from "../../components/Goftino";
import JMoment from "jalali-moment";

export default function OwnerLayout() {
  const token = localStorage.getItem("access_token");

  const viewport = useVirtualViewport();
  const divRef = useRef<HTMLDivElement>(null);
  const { pathname } = useLocation();
  const dispatch = useAppDispatch();

  const navigate = useNavigate();

  const { isOpenKeyboard } = useAppSelector((state) => state.settings);

  const { trigger: getOwnerWallet } = useSWRMutation(
    [`/Sender/GetWallet`, localStorage.getItem("access_token")],
    fetcherPost,
    {
      onSuccess: async (data) => {
        dispatch(setOwnerStock(data));
      },
    }
  );

  const { trigger: getUserInfoTrigger } = useSWRMutation(
    [`/User/GetUserInfo`, localStorage.getItem("access_token")],
    fetcherPost,
    {
      onSuccess: async (data) => {
        const { phoneValid, role, isConfirm } = data;

        if (role === 12) navigate("/driver/dashboard");
        dispatch(setPhoneValid(phoneValid));
        dispatch(setOwnerConfirm(!!isConfirm));
      },
    }
  );

  const { trigger: getOwnerInfo, isMutating: isgetOwnerInfoMutating } =
    useSWRMutation(
      [`/Driver/GetOwnerUserInfo`, localStorage.getItem("access_token")],
      fetcherPost,
      {
        onSuccess: async (data) => {
          const {
            postalCode,
            address,
            cityInfo,
            accountNr,
            cardNr,
            shNr,
            birthDate,
            bankName,
            ownerAttach2,
            ownerAttach1,
            ownerAttach3,
            ownerAttach4,
          } = data;

          dispatch(setOwnerInfo(data));

          const mydate = JMoment(birthDate);

          dispatch(
            setBirthDate({
              day: birthDate ? mydate.format("jDD") : "",
              month: birthDate ? mydate.format("jMM") : "",
              year: birthDate
                ? (Number(mydate.format("jYYYY")) - 1320).toString()
                : "",
            })
          );

          dispatch(
            setBankAccountInfo({
              accountNr,
              cardNr,
              shNr,
              bankName,
            })
          );

          dispatch(
            setAccomodationInfo({
              postalCode,
              address,
              cityInfo,
            })
          );

          dispatch(
            setAttachFiles({
              ownerAttach1: ownerAttach1,
              ownerAttach2: ownerAttach2,
              ownerAttach3: ownerAttach3,
              ownerAttach4: ownerAttach4,
            })
          );

          // dispatch(setDriverNobatQueueInfo(data));
        },
      }
    );
  useEffect(() => {
    if (!token) return;
    getOwnerWallet({});
    getOwnerInfo({});
    getUserInfoTrigger({}).catch((e) => {
      localStorage.clear();
      navigate("/login", { replace: true });
    });
  }, []);

  useEffect(() => {
    setTimeout(() => {
      dispatch(setOpenAuthSidebar(false));
      dispatch(setOpenDriverSidebar(false));
      dispatch(setOpenOwnerSidebar(false));
    }, 100);
  }, [pathname]);

  useEffect(() => {
    const divElement = divRef.current;

    const handleScroll = () => {
      if (divElement && divElement.scrollTop > 5) {
        dispatch(setHasScroll(true));
      } else {
        dispatch(setHasScroll(false));
      }
    };

    if (divElement) {
      divElement.addEventListener("scroll", handleScroll);
    }

    return () => {
      if (divElement) {
        divElement.removeEventListener("scroll", handleScroll);
      }
    };
  }, []);

  if (!token) return <Navigate to={"/login"} replace />;

  return (
    <Box
      ref={divRef}
      dir="rtl"
      sx={{
        height: `100vh`,
        backgroundColor: "bgColor.grey100",
        paddingBottom: pathname === "/owner/dashboard" ? "58px" : "70px",
        paddingTop: pathname === "/owner/dashboard" ? "0px" : "70px",
        position: "relative",
        overflowY: "auto",
        display: "flex",
        flexDirection: "column",
        overflowX: "hidden",
        "&::-webkit-scrollbar": {
          "-webkit-appearance": "none",
          width: "0px", // Hides scrollbar for WebKit browsers
        },
        scrollbarWidth: "none", // Hides scrollbar for Firefox
      }}
    >
      <OwnerSidebar />
      <CustomSnackbar />
      <CustomDialogBox />
      <Goftino />
      <Outlet />
      <BottomTabbar />
    </Box>
  );
}
